import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Modal, Row, Stack } from 'react-bootstrap';
// import '../../Scss/Form.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import RHFTextField from '../../FunctionalComponent/FormElement/RHTextField';
import RHSelectField from '../../FunctionalComponent/FormElement/RHSelectField';
import FormProvider from '../../FunctionalComponent/FormElement/FormProvider';
import Select from 'react-select';
import { toast } from 'react-toastify'
import { useGetCategoriesListQuery } from '../../Redux/category/categoryApi';
import { useProductListMutation } from '../../Redux/ProductSlice';
import { useCreateBannerMutation, useGetBannerQuery, useShowBannerMutation } from '../../Redux/banner/bannerApi';
import { useUplaodFileMutation } from '../../Redux/file/fileApi';
import { useGetActiveCouponslistMutation } from '../../Redux/CouponSlice';

function CreateBanner(props) {
    const { setBannerData, setOpen, BannerData, open, sliderID } = props;
    const [Createbanner, { data: createData, error: createErr, isLoading: deleteLoading, isSuccess: CreateSuccess }] = useCreateBannerMutation()
    const [showBanner, { }] = useShowBannerMutation()
    const { refetch } = useGetBannerQuery(`?name=${sliderID}`);
    const [fileUploadFn, { }] = useUplaodFileMutation();
    const [productListFn, { data: productList }] = useProductListMutation();

    const [CouponListFn, { data: couponList }] = useGetActiveCouponslistMutation();

    const [image, setImagefile] = useState(null)
    const [showImage, setShowImage] = useState()
    const [imagePath, setImagepath] = useState()

    let initialState = {
        id: BannerData?.id || '',
        name: "",
        couponId: '',
        categoryId: '',
        productId: '',
        sliderImage: '',
    };

    const { data: categoryData } = useGetCategoriesListQuery();

    const methods = useForm({
        defaultValues: initialState,
        mode: 'all',
    });

    const {
        handleSubmit,
        reset,
        setError,
        setValue,
        getValues,
        watch
    } = methods;

    const handleFileChange = async (e, setFile, name) => {
        const file = e.target.files?.[0];
        const fileName = e.target.name;
        setShowImage(true)
        const maxFileSizeMap = {
            sliderImage: 1024 * 10,
        };
        const maxSizeKB = maxFileSizeMap[fileName];
        // console.log('file', file)
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                if (reader.readyState === 2) {
                    const fileSize = file.size / 1024; // file size in KB
                    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];

                    // Validate file type
                    if (!allowedTypes.includes(file.type)) {
                        toast.error("Image type not supported. Please choose a jpg, jpeg, png, or webp file.");
                        return;
                    }

                    // Validate file size
                    if (fileSize > maxSizeKB) {
                        toast.error(`File size exceeds maximum limit (${maxSizeKB / 1024}MB). Please choose a smaller file.`);
                        return;
                    }
                    uploadFile(file)
                    setImagefile(reader.result);
                }
            };
            reader.readAsDataURL(file);
            setFile(file);

        }
    };

    const uploadFile = async (file) => {
        try {
            const formData = new FormData();
            formData.append("image", file);
            const response = await fileUploadFn(formData);
            setImagepath(response?.data?.response?.url)
            return response?.data?.response?.url
        } catch (error) {
            throw error;
        }
    };

    const onSubmit = () => {
        const data = getValues();
        Createbanner({ ...data, name: sliderID, sliderImage: imagePath })
            .then((res) => {
                if (res?.payload?.data?.statusCode == 201 || 200) {
                    setOpen(false)
                    refetch()
                }
            })
    }

    const handleDeleteImage = (imageType) => {
        if (imageType == "sliderImage") {
            setValue('sliderImage', ''); // Clear the specific image type
            setShowImage(false);
        }
    };

    useEffect(() => {
        if (BannerData?.id) {
            showBanner(BannerData?.id).then(res => {
                const getsizedata = res?.data?.response;
                Object.keys(initialState).forEach((fieldname) => {
                    setValue(fieldname, getsizedata[`${fieldname}`]);
                    setShowImage(true)
                    if (sliderID != "bannerSection" && fieldname === 'categoryId') {
                        const categoryIdValue = getsizedata[`${fieldname}`];
                        productListFn(`categoryId=["${categoryIdValue}"]`);
                    }
                    if (fieldname === 'sliderImage') {
                        const imageValue = getsizedata[`${fieldname}`]
                        setImagepath(imageValue)
                    }
                });
            });
        }
    }, [sliderID, BannerData?.id]);

    useEffect(() => {
        if (CreateSuccess) {
            setOpen(false)
            const message = createData?.message || "Delete successfully";
            toast.success(message);
            setBannerData({})
        }

    }, [createData, CreateSuccess, createErr]);

    console.log('couponList?.response', couponList)
    useEffect(() => {
        if (sliderID == "bannerSection") {
            CouponListFn()
        }
    }, [sliderID])
    console.log('setValue', getValues())
    return (
        <>
            <Modal id="showModal" className="fade zoomIn" size="md"
                show={open} onHide={() => { setOpen(!open) }} centered>
                <Modal.Header className="px-4 pt-4" closeButton>
                    <h5 className="modal-title fs-18" id="exampleModalLabel">Banner Slider</h5>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <FormProvider className="tablelist-form" methods={methods} onSubmit={handleSubmit(onSubmit)} >
                        <Row>
                            <div id="alert-error-msg" className="d-none alert alert-danger py-2"></div>
                            <input type="hidden" id="id-field" />
                            {sliderID != "bannerSection" ?
                                <>
                                    <Col lg={12}>
                                        <RHSelectField
                                            label={"Category"}
                                            name={"categoryId"}
                                            list={categoryData?.response?.map((categories) => ({
                                                name: categories?.name,
                                                value: categories?.id
                                            }))}
                                            productListFn={productListFn} // Pass your productListFn function here

                                        />
                                    </Col>
                                    <Col lg={12}>
                                        <RHSelectField
                                            label={"Product"}
                                            name={"productId"}
                                            list={productList?.response?.map((product) => {
                                                return ({ name: product?.productTitle, value: product?.id })
                                            })}

                                        />
                                    </Col>
                                </> :
                                <Col lg={12}>
                                    <RHSelectField
                                        label={"Coupon"}
                                        name={"couponId"}
                                        list={couponList?.response?.map((coupon) => {
                                            return ({ name: coupon?.name, value: coupon?.id })
                                        })}

                                    />
                                </Col>}

                            <Col lg={12}>
                                <div className="mb-3">
                                    <Form.Label htmlFor={getValues('sliderImage') ? "" : "sliderImage"} className="form-label d-block">Banner Image <span className="text-danger">*</span></Form.Label>
                                    <div className="position-relative d-inline-block">
                                        <div className="position-absolute top-100 start-100 translate-middle">
                                            <Form.Label htmlFor={getValues('sliderImage') ? "" : "sliderImage"} className="mb-0" data-bs-toggle="tooltip" data-bs-placement="right" title="Select Banner Image">
                                                <span className="avatar-xs d-inline-block">
                                                    <span className="avatar-title bg-light border rounded-circle text-muted cursor-pointer">
                                                        {getValues('sliderImage') && showImage ?
                                                            <i className="ri-delete-bin-5-line" onClick={() => handleDeleteImage('sliderImage')}></i> :
                                                            <i className="ri-image-fill" onClick={() => setShowImage(!showImage)}></i>
                                                        }
                                                    </span>
                                                </span>
                                            </Form.Label>
                                            {showImage &&
                                                <input className="form-control d-none" name='sliderImage' id="sliderImage" type="file" onChange={e => handleFileChange(e, setImagefile)} />
                                            }
                                        </div>
                                        <div className="avatar-lg">
                                            <div className="avatar-title bg-light rounded-3">
                                                {getValues('sliderImage') && showImage ? (
                                                    <img src={getValues('sliderImage')} alt="" id="category-img" className="avatar-md h-auto rounded-3 object-fit-cover" />
                                                ) : (
                                                    <img src={image} id="category-img" className="avatar-md h-auto rounded-3 object-fit-cover" />
                                                )}

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </Col>

                            <Col lg={12} className="modal-footer">
                                <div className="hstack gap-2 justify-content-end">
                                    <Button className="btn-ghost-danger" onClick={() => { setOpen(!open) }}><i className="ri-close-line align-bottom me-1"></i> Close</Button>
                                    <Button variant='primary' id="add-btn" onClick={onSubmit} type="button">{BannerData?.id ? "Update" : "Submit"}</Button>
                                </div>
                            </Col>
                        </Row>
                    </FormProvider>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default CreateBanner;
